<script type="text/ecmascript-6">
  export default {
    name: 'RcTableColumn',
    render(h) {
      // slots 也要渲染，需要计算合并表头
      return h('div', this.$slots.default);
    }
  }
</script>
